<div class="container">
  <h1>Page Layouts</h1>
  @if (!editConfiguration) {
    <pub-configuration-list (setEditConfig)="editConfiguration=$event">
    </pub-configuration-list>
  }
  @if (editConfiguration) {
    <div class="row">
      <div class="col-sm">
        <pub-edit-configuration-form [editConfiguration]="editConfiguration"
        (editingDone)="editingDone()"></pub-edit-configuration-form>
      </div>
    </div>
  }
</div>
